import { Fragment, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import BulletinBoardBtn from '../../images/apps-bulletinboard.svg'
import InfoHubBtn from '../../images/apps-infohub.svg'
import GrievanceBtn from '../../images/apps-grievance.png'
import ResignationBtn from '../../images/apps-resignation.png'
// import WorkerPerformanceGradeLogo from '../../images/worker_performance_grading.png'
import WorkerPerformanceGradeLogo from '../../images/apps-workergrading.png'
import SettingsBtn from '../../images/apps-settings.svg'
import Logo from '../../images/logo.svg'
import './AllAppsCentre.css'

const AllAppsCentre = ({ username, loginList, isActive, grievancePermission }) => {
    const [showAll, setShowAll] = useState(false)
    const [showBulletin, setShowBulletin] = useState(false)
    const [showInfoHub, setShowInfoHub] = useState(false)
    const [showGrievance, setShowGrievance] = useState(false)
    const [showResignation, setShowResignation] = useState(false)
    const [showWorkerPerformanceGrading, setShowWorkerPerformanceGrading] = useState(false)
    // const [showSettings, setShowSettings] = useState(false)

    useEffect(() => {
        if (loginList) {
            const loginListFromParent = loginList;

            const showAll = loginListFromParent.some((item) =>
                (item.permissionName.includes("Admin Role") && item.permissionType.includes("view"))
            )

            const showBulletin = loginListFromParent.some((item) =>
                (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("view"))
            )

            const showInfoHub = loginListFromParent.some((item) =>
                (item.permissionName.includes("Info Hub") && item.permissionType.includes("view"))
            )

            const showResignation = loginListFromParent.some((item) =>
                (item.permissionName.includes("Resignation") && item.permissionType.includes("view"))
            )

            const showWorkerPerformanceGrading = loginListFromParent.some((item) =>
                (item.permissionName.includes("Worker Performance Grading") && item.permissionType.includes("view"))
            )

            // const showSettings = loginListFromParent.some((item) =>
            //     (item.permissionName.includes("Create Bus Driver Account") && item.permissionType.includes("view"))
            //     ||
            //     (item.permissionName.includes("Reset Phone Number") && item.permissionType.includes("view"))
            //     ||
            //     (item.permissionName.includes("Reset Password") && item.permissionType.includes("view"))
            // )

            if (loginListFromParent) {
                setShowAll(showAll)
                setShowBulletin(showBulletin)
                setShowInfoHub(showInfoHub)
                setShowResignation(showResignation)
                setShowWorkerPerformanceGrading(showWorkerPerformanceGrading)
                // setShowSettings(showSettings)
            }
        }

    }, [loginList])

    useEffect(() => {
        if (grievancePermission) {
          const grievancePermissionFromParent = grievancePermission;
          
          if (grievancePermissionFromParent == 1) {
            setShowGrievance(true);
          }
        }
    
      }, [grievancePermission])

    return (
        <div className='hero-container'>
            <div className='hero-logo-wrapper'>
                <img src={Logo} className='hero-logo' alt='' />
            </div>
            <div className={`${isActive ? 'container is-active' : 'container'}`} style={{ border: 'none'}}>
                <Row>
                    <Col>
                        <h4 style={{ fontSize: '28px'}}>Good Health, </h4>
                        <h2 style={{ fontSize: '36px', fontWeight: '600'}}>{username} !</h2>
                    </Col>
                </Row>
                <Row style={{ marginTop: '10vh'}}>
                    <header className='header'>
                        <h2 style={{ fontSize: '28px' }}>Apps Centre</h2>
                    </header>
                    { (showAll || showBulletin) &&
                    <Col>
                        <div className='text-center apps-centre-icon'>
                            <Link to='/bulletinboard'>
                                <img src={BulletinBoardBtn} className='apps-logo' alt='' />
                                <Row>
                                    <span className='apps-title'>
                                        Bulletin Board
                                    </span>
                                </Row>
                            </Link>
                        </div>
                    </Col>
                    }
                    { (showAll || showInfoHub) &&
                    <Col>
                        <div className='text-center apps-centre-icon'>
                            <Link to='/infohub'>
                                <img src={InfoHubBtn} className='apps-logo' alt='' />
                                <Row>
                                    <span className='apps-title'>
                                        Info Hub
                                    </span>
                                </Row>
                            </Link>
                        </div>
                    </Col>
                    }
                    { showGrievance &&
                    <Col>
                        <div className='text-center apps-centre-icon'>
                            <Link to='/grievance'>
                                <img src={GrievanceBtn} className='apps-logo' alt='' />
                                <Row>
                                    <span className='apps-title'>
                                        Grievance
                                    </span>
                                </Row>
                            </Link>
                        </div>
                    </Col>
                    }
                    { (showAll || showResignation) &&
                    <Col>
                        <div className='text-center apps-centre-icon'>
                            <Link to='/resignation'>
                                <img src={ResignationBtn} className='apps-logo' alt='' />
                                <Row>
                                    <span className='apps-title'>
                                        Resignation
                                    </span>
                                </Row>
                            </Link>
                        </div>
                    </Col>
                    }
                    { (showWorkerPerformanceGrading) &&
                    <Col>
                        <div className='text-center apps-centre-icon'>
                            <Link to='/workerPerformanceGrade'>
                                <img src={WorkerPerformanceGradeLogo} className='apps-logo' alt='' />
                                <Row>
                                    <span className='apps-title'>
                                        Worker Performance Grading
                                    </span>
                                </Row>
                            </Link>
                        </div>
                    </Col>
                    }
                    {/* { (showAll || showSettings) &&
                    <Col>
                        <div className='text-center apps-centre-icon'>
                            <Link to='/settings'>
                                <img src={SettingsBtn} className='apps-logo' alt='' />
                                <Row>
                                    <span className='apps-title'>
                                        Settings
                                    </span>
                                </Row>
                            </Link>
                        </div>
                    </Col>
                    } */}
                    <Col style={{ visibility: 'hidden' }}></Col>
                    <Col style={{ visibility: 'hidden' }}></Col>
                    <Col style={{ visibility: 'hidden' }}></Col>
                    {
                        (showBulletin && !showInfoHub && !showAll) &&
                        <Fragment>
                            <Col style={{ visibility: 'hidden' }}></Col>
                        </Fragment>
                    }
                    {
                        (showInfoHub && !showBulletin && !showAll) &&
                        <Fragment>
                            <Col style={{ visibility: 'hidden' }}></Col>
                        </Fragment>
                    }
                    {/* {
                        (showSettings && !showBulletin && !showInfoHub && !showAll) &&
                        <Fragment>
                            <Col style={{ visibility: 'hidden' }}></Col>
                            <Col style={{ visibility: 'hidden' }}></Col>
                        </Fragment>
                    } */}
                </Row>
            </div>
        </div>
    )
}

export default AllAppsCentre
